import { AssetCreationName, MediaAssetType } from '@/types/media';
import { creditsBillingService, CreditsPriceItem } from './CreditsBillingService';

export class MediaAssetPrices {
  public static isMediaAsset(name: string): boolean {
    return Object.values(AssetCreationName).includes(name as AssetCreationName);
  }

  public static getPriceItems(name: AssetCreationName): CreditsPriceItem[] {
    switch (name) {
      case AssetCreationName.studioVideo:
        return [CreditsPriceItem.studioVideo];
      default:
        return [];
    }
  }

  public static getPrice(priceItems: CreditsPriceItem[]): number {
    return creditsBillingService.getAmount(priceItems);
  }
}
